/** Set on rows from Flash JSON before bake (UTC semantics). Removed after bake. */
export const PREVIEW_ROW_FLASH_IMPORT = 'flash_import';

/** Row `date` (YYYY-MM-DD) and `hour` (HH:MM:SS) are final; set at fetch/load only. */
export const PREVIEW_ROW_BAKED = '_preview_baked';

/** Map raw provider type (Pluggy / Flash / etc.) to flow In/Out. */
export function flowTypeFromPreviewType(type) {
  const t = String(type || '').toUpperCase();
  if (t === 'CREDIT' || t === 'INCOME' || t === 'DEPOSIT') return 'In';
  if (t === 'DEBIT' || t === 'EXPENSE' || t === 'OUT' || t === 'OPEN_LOOP_PAYMENT') return 'Out';
  return 'unknown';
}
